import { Component, Entity, System } from "aframe";




export interface InputActionDetail
{
	input? : InputComponent;
	timestamp : number; //Date.now() when the input started
	action : string;
	amount : number;
	getRay : GetRayCallback;
	feedback : FeedbackDelegate;
	instant? : boolean;
}
export type InputActionEvent = Event & { detail : InputActionDetail };
export type GetRayCallback = (origin : any, direction : any, setter : Function ) => void;
export type FeedbackDelegate = (intensity : number, milliseconds? : number, action? : string) => void;

export type InputSystemData = { [key : string] : string }

export interface InputSystem extends System
{
	data : InputSystemData;
	isPrimaryInput? : boolean;
	layout? : { [key : string] : string };
}
export interface InputComponent extends Component
{
	system : InputSystem;	
	actions : { [action : string] : { 
		keys : { [key:string] : number },
		detail : InputActionDetail | null
	} };
	feedback(intensity : number, milliseconds? : number, action? : string) : void;
}


export const inputSystemSchema = { "" : { type : "string"} }




export function press(input : InputComponent, action : string, key : string, amount : number, getRay : GetRayCallback, feedback? : FeedbackDelegate, emitter? : Entity ) : boolean
{
	if(action.startsWith("!")) return toggle(input, action.slice(1), key, amount, getRay, feedback, emitter);
	
	const data = input.actions[ action ] || ( input.actions[action] = { keys : {}, detail : null } );

	if(!(key in data.keys))
		data.keys[key] = Date.now();
	
	if(data.detail)
		data.detail.amount = amount; //Let's hope different keys don't give different amounts...
	else
	{
		feedback ||= (i,ms,ac) => input.feedback(i,ms,ac);
		data.detail = { input, timestamp : Date.now(), action, amount, getRay, feedback };
		(emitter || input.el).dispatchEvent(new CustomEvent("input-begin",  
			{ detail: data.detail, bubbles : true, cancelable : true } ));
	}
	return true;
};

export function release(input : InputComponent, action : string, key : string, emitter? : Entity) : boolean
{
	if(action.startsWith("!")) return true; //Toggle key : act on keydown
	const data = input.actions[ action ];
	if(!(data && (key in data.keys))) return true;
	delete data.keys[key];
	for(let any in data.keys) return true; //Still some inputs
	data.detail!.amount = 0;
	(emitter || input.el).dispatchEvent(new CustomEvent("input-end", { detail : data.detail, bubbles : true } ));
	data.detail = null;
	delete input.actions[action];
	return true;
};

export function toggle(input : InputComponent, action : string, key : string, amount : number, getRay : GetRayCallback, feedback? : FeedbackDelegate, emitter? : Entity) : boolean
{
	const data = input.actions[ action ];
	return (data && (key in data.keys)) ?
		release(input, action, key, emitter) : 
		press(input, action, key, amount, getRay, feedback, emitter);
};

